export const ACCOUNT_NUMBER_DEFAULT_VALUE = { customerName: '', customerReference: '' };

export const FREQUENT_CUSTOMERS_LIMIT = 10;
export const SEARCH_CUSTOMERS_LIMIT = 200;
export const SEARCH_CUSTOMERS_MIN_CHAR = 3;
export const FREQUENT_CUSTOMERS_MIN_CHAR = 1;
